import { render } from "./CoffeeDetailForm.vue?vue&type=template&id=c36df518&scoped=true"
import script from "./CoffeeDetailForm.vue?vue&type=script&lang=js"
export * from "./CoffeeDetailForm.vue?vue&type=script&lang=js"

import "./CoffeeDetailForm.vue?vue&type=style&index=0&id=c36df518&scoped=true&lang=css"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36df518"]])

export default __exports__